const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/reviews.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/reviews')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});